var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-filter-advanced-group',{attrs:{"title":"Families","count":_vm.count}},[_c('core-filter-input-suggest',{attrs:{"placeholder":"Start typing a family name...","toggle":true,"field":"family_name","filter":_vm.value('families'),"api":"families/suggest","data":"families"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }